import {
  DRIFT_CHAT_SERVICE_CONVERSATIONS_DIMENSIONS,
  DRIFT_CHAT_SERVICE_CONVERSATIONS_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const DeflectionQuery: CubeQuery = {
  name: 'DeflectionQuery',
  queryName: 'DeflectionQuery',
  query: {
    measures: [
      DRIFT_CHAT_SERVICE_CONVERSATIONS_MEASURES.COUNT_SERVICE_CONVERSATIONS,
      DRIFT_CHAT_SERVICE_CONVERSATIONS_MEASURES.COUNT_DEFLECTED_CONVERSATIONS,
    ],
  },
}

export const DeflectionPlaybookQuery: CubeQuery = {
  name: 'DeflectionPlaybookQuery',
  queryName: 'DeflectionPlaybookQuery',
  query: {
    measures: [
      DRIFT_CHAT_SERVICE_CONVERSATIONS_MEASURES.COUNT_SERVICE_CONVERSATIONS,
      DRIFT_CHAT_SERVICE_CONVERSATIONS_MEASURES.COUNT_DEFLECTED_CONVERSATIONS,
    ],
    dimensions: [DRIFT_CHAT_SERVICE_CONVERSATIONS_DIMENSIONS.PLAYBOOK_ID],
  },
}
